module.exports = __webpack_public_path__ + "img/store_vip_benefit_coins.e216599a.png";